import { Component, h, Prop, Listen, Element, Method } from '@stencil/core';

@Component({
  tag: 'jackery-dropdown',
  styleUrl: 'jackery-dropdown.css'
})
export class JackeryDropdown {
  @Element() element: HTMLElement;
  /**
   * 控制content显示隐藏
   */
   @Prop({ mutable: true, reflect: true }) isActive = false;

   /**
    * Align right
    */
   @Prop() isRight = false;
 
   /**
    * menu在button上面？
    */
   @Prop() isUp = false;

   /**
    * 允许hover触发
    */
    @Prop() hoverAble = false;
 
   /**
    * Handle Trigger click action
    */
   private handleTriggerClick = (): void => {
     if(this.hoverAble) return
     this.isActive = !this.isActive;
   };

   @Listen('click', { target: 'window', capture: true })
   handleClickOutside(event: MouseEvent) {
    const clickedElement = event.composedPath()[0] as HTMLElement; // 点击元素本身
    if(!this.element.contains(clickedElement as Node)) {
      this.isActive = false
    }
   }

   @Listen('keydown', { target: 'window' })
   handleKeyDown(event: KeyboardEvent) {
    if (event.key.toLowerCase() === 'escape' && this.isActive) {
      this.isActive = false
    }
   }

   @Method()
   async dropCallback(e: boolean) { // 暴露给父组件调用
     this.isActive = e
   }

  render() {
    return (
      <div
        class={{
          dropdown: true,
          'is-active': this.isActive,
          'is-right': this.isRight,
          'is-up': this.isUp,
          'is-hover': this.hoverAble
        }}
      >
        <div 
          onClick={this.handleTriggerClick} class="dropdown-trigger"
        >
          <slot name="trigger" aria-haspopup="true" />
        </div>

        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <slot />
          </div>
        </div>
      </div>
    );
  }
}
